import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative lg:min-h-screen bg-cover bg-center bg-no-repeat bg-other-hero">
      <div className="relative container px-3 py-10 flex flex-col justify-center items-center gap-[24px] text-white text-center lg:min-h-[90dvh] ">
        <h1 className="text-[24px] lg:text-[40px] font-bold">
          Model Fine-tuning
        </h1>
        <p className="text-lg md:text-xl max-w-[793px] mx-auto text-center">
          Transform pre-trained models into specialized solutions tailored to
          your unique challenges. Our fine-tuning services adapt existing models
          to perform optimally with your data, improving accuracy while reducing
          computational requirements.
        </p>
        <Link
          className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium"
          to="/signup"
        >
          Begin Fine-tuning
        </Link>
      </div>
    </section>
  );
};

export default Hero;
